module.exports = __webpack_public_path__ + "img/icon-headphone.ab995c91.svg";